/*
 * @Author: shiguang
 * @Date: 2023-08-07 17:09:00
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2024-01-17 18:03:47
 * @Description: utils
 */
import confirmDialog from '@/components/common/ConfirmDialog'
import store, { useRtfix, useUser } from '@/store'
import { t } from '@/plugins/i18n'
import { useRouter } from 'vue-router'
import { confirmLoginWithNoCurShop } from '@/util/useConfirm'
import { TaEvent, taTrack } from '@/util/buryingPoint'

/**
 * 直播详情页 href
 * @param activityId 直播id
 */
export const getLiveDetailPageHref = (activityId: string) => {
  return `/live?activityId=${activityId}`
}

/** 直播状态枚举 */
export enum ENUM_LIVE_STATUS{
  /** 直播中 */
  LIVING = 1,
  /** 预告 */
  ANNOUNCE_IN_ADVANCE = 2,
  /** 回放 */
  BACKPLAY = 3,
  /** 停止 */
  STOP = 3,
}

/**
 * 展示弹窗，直播相关操作需要会员
 */
interface ShowIfNeedMemberDialogForLiveOptins{
  onOK?: () => void;
}
export const showIfNeedMemberDialogForLive = (options: ShowIfNeedMemberDialogForLiveOptins) => {
  const { onOK } = options
  const user = useUser()

  if (!user) {
    if (window.location.pathname.endsWith('/hub/ec')) {
      confirmLoginWithNoCurShop(() => {}, () => {
        taTrack({
          event: TaEvent.PUPUP_WINDOW,
          value: {
            position: 'login',
            source: 'live_broadcast'
          }
        })
      })
      return true
    }
    window.location.href = '/login?redirect=' + encodeURIComponent(window.location.href)
    return true
  }
  const membership = store.getters.membership
  const templateLevel = membership?.templateLevel ?? 0
  if (templateLevel > 0) return false
  confirmDialog({
    title: '<span class="iconfont icon-gantanhao" style="margin-right:4px;"></span>提示',
    text: t('请购买会员后观看直播。'),
    htmlNode: true,
    okText: t('开通会员'),
    cancelText: t('我已知晓'),
    closeOnClickModal: false,
    onOk: onOK,
    onCancel: ({ hideModal }) => {
      const isLiveDetail = window.location.pathname.endsWith('/live')
      if (isLiveDetail) {
        const isB2B = useUser().systemSource === 2
        window.location.href = '/hub/ec'
      }
      hideModal()
    }
  }).then(() => {
    // debugger
    // const router = useRouter()
    // router.push(useRtfix('VipLevel'))
    // eslint-disable-next-line no-unused-expressions
    // setTimeout(() => {
    // }, 10)
    // readPopUpWindowByType({
    //   type: 0
    // })
    // router.push(useRtfix('setupUser'))
  })
  return true
}
